import { map, startCase } from 'lodash';

export const prepareDashboardTitle = (isReauthenticateRoute, extendedChecks) => {
    let dashboardTitle = 'Identity Authentication';

    if (isReauthenticateRoute) dashboardTitle = 'ReAuthenticate™';

    if (extendedChecks?.length === 1) dashboardTitle = 'Identity Authentication & Background Check';

    if (extendedChecks?.length > 1) dashboardTitle = 'Identity Authentication & Background Checks';

    return dashboardTitle;
};

export const prepareDashboardDescription = (isReauthenticateRoute, extendedChecks) => {
    let verificationInfoText = 'Your identity will be verified.';
    if (extendedChecks.length > 1) {
        const formattedArray = map(extendedChecks, startCase);
        const lastItem = formattedArray.pop();
        const formattedString = `Your Identity, ${formattedArray.join(
            ', '
        )} and ${lastItem} will be verified.`;
        verificationInfoText = formattedString;
    } else if (extendedChecks.length === 1) {
        verificationInfoText = `Your Identity and ${startCase(extendedChecks)} will be verified.`;
    }

    return isReauthenticateRoute
        ? 'You will be ReAuthenticated using your selfie.'
        : verificationInfoText;
};
